import { IApplicationState } from '../../types/redux';
import {
  TOfferFromHistoryData,
  TRoomsFilterActiveValue,
  TRoomsFilterOptions,
  TStatusFilterActiveValue,
  TStatusFilterOptions,
  TTypeFilterOptions,
  ETypeFilterValues,
  TCategoryFilterOptions,
  TCategoriesFilterActiveValue,
} from '../../types/offerHistory';

export const selectIsListingError = (state: IApplicationState): boolean => state.offersHistory.data.listing.isError;

export const selectIsListingLoading = (state: IApplicationState): boolean =>
  state.offersHistory.data.listing.isFetching;

export const selectOffersHistoryData = (state: IApplicationState) => state.offersHistory.data.listing;

export const selectOffersHistoryExists = (state: IApplicationState) => Boolean(state.offersHistory.offersHistoryExists);

export const selectOffersHistorySpoilerData = (state: IApplicationState) => state.offersHistory.data.listingSpoiler;

export const selectStatusFilters = (state: IApplicationState): TStatusFilterOptions | null => {
  return state.offersHistory.data.listing.data?.statusFilters || null;
};

export const selectRoomsFilters = (state: IApplicationState): TRoomsFilterOptions | null => {
  return state.offersHistory.data.listing.data?.roomsFilters || null;
};

export const selectLocationFilters = (state: IApplicationState): TTypeFilterOptions | null => {
  return state.offersHistory.data.listing.data?.locationFilters || null;
};

export const selectCategoriesFilters = (state: IApplicationState): TCategoryFilterOptions | null => {
  return state.offersHistory.data.listing.data?.categoriesFilters || null;
};

export const selectActiveCategoriesFilter = (state: IApplicationState): TCategoriesFilterActiveValue =>
  state.offersHistory.categoriesFilterActiveValue;

export const selectIsOfferFromListingLoading = (state: IApplicationState): boolean =>
  state.offersHistory.data.offers.isFetching;

export const selectIsOfferFromListingError = (state: IApplicationState): boolean =>
  state.offersHistory.data.offers.isError;

export const selectIsOfferFromListingAuthError = (state: IApplicationState) =>
  state.offersHistory.data.offers.isAuthError;

export const selectPageNumber = (state: IApplicationState): number => state.offersHistory.page;

export const selectResultsOnPage = (state: IApplicationState): number => state.offersHistory.resultsOnPage;

export const selectActiveRoomsFilter = (state: IApplicationState): TRoomsFilterActiveValue =>
  state.offersHistory.roomsFilterActiveValue;

export const selectActiveStatusFilter = (state: IApplicationState): TStatusFilterActiveValue =>
  state.offersHistory.statusFilterActiveValue;

export const selectActiveTypeFilter = (state: IApplicationState) => state.offersHistory.typeFilterActiveValue;

export const selectActiveOfferId = (state: IApplicationState) => state.offersHistory.activeOfferId;

export const selectIsFiltersChanged = (state: IApplicationState) => state.offersHistory.isFiltersChanged;

export const selectViewedOffers = (state: IApplicationState) => state.offersHistory.viewedOffers;

export const selectDefaultFilters = (state: IApplicationState) => state.offersHistory.defaultFilters;

/** Возвращает данные для одного оффера из истории офферов */
export const selectOfferFromHistory = (state: IApplicationState): TOfferFromHistoryData | null => {
  const activeOfferId = selectActiveOfferId(state);

  if (!activeOfferId) {
    return null;
  }

  return state.offersHistory.data.offers.data[activeOfferId] || null;
};

const mapLocationVal: Record<ETypeFilterValues, string> = {
  [ETypeFilterValues.NearbyHouses]: 'similar',
  [ETypeFilterValues.SameHouse]: 'this',
};

export const selectFiltersStringified = (state: IApplicationState) => {
  const roomsFilterValue = selectActiveRoomsFilter(state) || 'all';
  const statusFilterValue = selectActiveStatusFilter(state) || 'all';
  const typeFilterValue = selectActiveTypeFilter(state) as ETypeFilterValues;

  return typeFilterValue
    ? `${mapLocationVal[typeFilterValue]}/${statusFilterValue}/${roomsFilterValue}`
    : `${statusFilterValue}`;
};
